module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-235.dc09954.woff2";